import { ClientPolicySearchDTO } from '@core/pages/new-business-register/api'
import { DateTime } from '@master/services/DateTime'

export class ReconReportSearchCriteria implements ClientPolicySearchDTO {
  adviserOids = undefined
  opsApprovalStartDate = undefined
  opsApprovalEndDate = undefined
  creationStartDate = undefined
  creationEndDate = undefined
  status = []
  policyNumberContains = undefined
  principalOids = undefined
  mainOwnerOids = undefined
  supervisorOids = undefined
  servicingOids = undefined
  page = undefined
  size = undefined

  currentPreselectedReport = ''

  prefillSearchCriteria () {
    switch (this.currentPreselectedReport) {
      case 'productionYTD':
        this.fillProductionYTD()
        break
      default:
        this.resetAllKeys()
        break
    }
  }

  productionYTDSearchVerification () {
    if (!this.opsApprovalStartDate) {
      throw new Error('There is no start date.')
    }
    return false
  }

  fillProductionYTD () {
    this.resetAllKeys()
    this.status = ['approved_by_ops']
    const date = new DateTime()
    date.set(0, 'millisecond')
    date.set(0, 'second')
    date.set(0, 'minute')
    date.set(0, 'hour')
    date.set(1, 'date')
    date.set(0, 'month')
    this.opsApprovalStartDate = date.time
    this.opsApprovalEndDate = new DateTime().time
  }

  resetAllKeys () {
    Object.keys(this).forEach(key => {
      if (key === 'currentPreselectedReport') {
        return
      }
      if (key === 'status') {
        this[key] = []
        return
      }
      this[key] = undefined
    })
  }
}
